import React from 'react';
import Image from 'next/image';

interface CustomMaskIconProps {
  url: string;
  alt: string;
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

const CustomMaskIcon = ({
  url,
  alt,
  color,
  width = 56,
  height = 56,
  className = '',
}: CustomMaskIconProps) => {
  if (color) {
    return (
      <span
        className={className}
        style={{
          width,
          height,
          backgroundColor: color,
          WebkitMaskImage: `url(${url})`,
          maskImage: `url(${url})`,
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
          display: 'inline-block',
        }}
        aria-label={alt}
      />
    );
  }
  return (
    <Image
      src={url}
      alt={alt}
      width={width}
      height={height}
      className={className}
    />
  );
};

export default CustomMaskIcon;
